import React from 'react';
import styled from 'styled-components';

const AdContainer = styled.div`
  width: 100%;
  margin: ${props => props.$margin || '30px 0'};
  padding: ${props => props.$padding || '0'};
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${props => props.$height || '250px'};
  background: ${props => props.$bgColor !== undefined ? props.$bgColor : (props.$showBox ? 'rgba(255, 255, 255, 0.02)' : 'transparent')};
  border: ${props => props.$border !== undefined ? props.$border : (props.$showBox ? '1px dashed rgba(255, 255, 255, 0.1)' : 'none')};
  border-radius: ${props => props.$showBox ? '12px' : '0'};
  position: relative;
  overflow: ${props => props.$overflow || 'visible'};
  
  @media (max-width: 768px) {
    min-height: ${props => props.$mobileHeight || '200px'};
    margin: ${props => props.$mobileMargin || '20px 0'};
  }
`;

const AdContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  
  > * {
    max-width: 100%;
  }
  
  iframe {
    max-width: 100%;
    border: none;
    display: block;
  }
  
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  
  a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
  
  div {
    width: 100%;
    overflow: visible;
  }
`;

const AdLabel = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const AdBanner = ({ 
  adCode, 
  adImage, 
  adLink, 
  height = '250px', 
  mobileHeight = '200px',
  margin = '30px 0',
  mobileMargin = '20px 0',
  padding = '0',
  bgColor,
  border,
  showLabel = true,
  showBox = false,
  overflow = 'visible'
}) => {
  if (!adCode && !adImage && !adLink) {
    return null;
  }

  const renderAd = () => {
    if (adCode) {
      // HTML/JavaScript reklam kodu
      return <div dangerouslySetInnerHTML={{ __html: adCode }} />;
    }
    
    if (adImage && adLink) {
      // Resim reklamı
      return (
        <a href={adLink} target="_blank" rel="noopener noreferrer">
          <img src={adImage} alt="Reklam" />
        </a>
      );
    }
    
    if (adImage) {
      // Sadece resim
      return <img src={adImage} alt="Reklam" />;
    }
    
    return null;
  };

  return (
    <AdContainer 
      $height={height}
      $mobileHeight={mobileHeight}
      $margin={margin}
      $mobileMargin={mobileMargin}
      $padding={padding}
      $bgColor={bgColor}
      $border={border}
      $showBox={showBox}
      $overflow={overflow}
    >
      {showLabel && <AdLabel>Reklam</AdLabel>}
      <AdContent>
        {renderAd()}
      </AdContent>
    </AdContainer>
  );
};

export default AdBanner;

